<template>
    <v-row align="stretch" class="mb-8">
        <v-col cols="12" xl="2" class="d-flex align-center justify-center align-self-stretch py-4">
            <slot name="icon" />
        </v-col>
        <slot />
    </v-row>
</template>

<script>
export default {
    name: "DashboardStatsRow",
};
</script>
